// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const flaaffy: PokeData = {
  "id": 180,
  "name": "flaaffy",
  "height": 8,
  "weight": 133,
  "base_experience": 128,
  "types": [
    PokeType.ELECTRIC
  ],
  "api_moves": [
    "tackle",
    "take-down",
    "growl",
    "thunder-shock",
    "thunder-wave",
    "thunder",
    "confuse-ray",
    "light-screen",
    "cotton-spore",
    "charge",
    "signal-beam",
    "power-gem",
    "discharge",
    "charge-beam",
    "electro-ball",
    "cotton-guard",
    "dazzling-gleam"
  ],
  "moves": [
    "tackle",
    "growl",
    "thunder-shock",
    "thunder",
    "confuse-ray",
    "dazzling-gleam",
    "thunder-fang",
    "thunderbolt",
    "wild-charge",
    "volt-switch",
    "zap-cannon",
    "electric-terrain",
    "thunder-punch"
  ],
  "evolution_chain": {
    "id": 89,
    "item": null,
    "species": [
      {
        "name": "mareep",
        "order": 208,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "flaaffy",
        "order": 209,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": 179,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 15,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "ampharos",
        "order": 210,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": 180,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 63.75,
    "speed": 45,
    "ability_power": 80
  },
  "stat_changes": [],
  "catch_rate": 120,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
